  <template>
  <f7-page>
    <f7-navbar>
      <f7-nav-title class="text-madai">Contáctanos</f7-nav-title>
    </f7-navbar>
    <f7-block>
      <p>Para cualquier duda, ponemos a tu disposición los siguientes canales de contacto:</p>
    </f7-block>
    <f7-block>
      <f7-row>
        <f7-col class="text-center">
          <f7-link href="https://www.facebook.com/madai.dis" external target="_blank">
            <img src="assets/img/facebook.svg" alt="" width="60">
          </f7-link>
          <span class="d-block m-t-10">
            <f7-link href="https://www.facebook.com/madai.dis" external target="_blank">Madai</f7-link>
          </span>
        </f7-col>
        <f7-col class="text-center">
          <f7-link href="https://api.whatsapp.com/send?phone=8120140511" external target="_blank">
            <img src="assets/img/whatsapp.svg" alt="" width="60">
          </f7-link>
          <span class="d-block m-t-10">
            <f7-link href="https://api.whatsapp.com/send?phone=8120140511" external target="_blank">+52 181 2014 0511</f7-link>
          </span>
        </f7-col>
      </f7-row>
    </f7-block>
    <f7-block>
      <p>O bien, puedes llenar el siguiente formulario y nos contactaremos contigo lo antes posible.</p>
    </f7-block>
    <f7-list no-hairlines>
      <f7-list-input
        class="required"
        type="text"
        placeholder="Nombre"
        label="Escribe tu nombre completo"
        :value="contacto.nombre"
        @input="contacto.nombre = $event.target.value"
        clear-button
      ></f7-list-input>

      <f7-list-input
        class="required"
        type="text"
        placeholder="Correo"
        label="Escribe un correo válido"
        :value="contacto.correo"
        @input="contacto.correo = $event.target.value"
        clear-button
      ></f7-list-input>

      <f7-list-input
        class="required"
        type="text"
        placeholder="Teléfono"
        label="Teléfono con lada"
        :value="contacto.telefono"
        @input="contacto.telefono = $event.target.value"
        clear-button
      ></f7-list-input>

      <f7-list-input
        class="required"
        type="textarea"
        placeholder="Mensaje"
        label="Cualquier duda que tengas puedes escribirla aquí"
        :value="contacto.mensaje"
        @input="contacto.mensaje = $event.target.value"
        clear-button
      ></f7-list-input>
    </f7-list>

    <f7-list inset>
      <!-- <f7-list-button title="Enviar mensaje" color="madai"></f7-list-button> -->
      <f7-list-item>
        <f7-button class="margin-auto" fill @click="enviarMensaje"
        :disabled="contacto.nombre === '' || contacto.correo === '' || contacto.telefono === '' || contacto.mensaje === ''">
          Enviar Mensaje
        </f7-button>
      </f7-list-item>
    </f7-list>
    <f7-block>
      <div class="bold text-center fs-12">
        2019 Madai. Todos los derechos reservados.
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
export default {
  data () {
    return {
      contacto: {
        nombre: '',
        correo: '',
        telefono: '',
        mensaje: ''
      }
    }
  },
  methods: {
    enviarMensaje () {
      const correo = {
        para: 'contactomadai@gmail.com',
        asunto: 'Contacto Formulario Madai',
        mensaje: `
          <div>
            <div>Nombre: ${this.contacto.nombre} </br></div>
            <div>Correo: ${this.contacto.correo} </br></div>
            <div>Teléfono: ${this.contacto.telefono} </br></div>
            <div>Mensaje: ${this.contacto.mensaje} </br></div>
          </div>
        `
      }
      window.emailjs.send('madai_no_reply', 'custom_template_2', correo)
        .then(response => {
          console.log('SUCCESS!', response.status, response.text)

          this.$f7.dialog.alert('El mensaje ha sido enviado, en breve nos contactaremos contigo.', `MADAI`, () => {
            setTimeout(() => {
              this.contacto = {
                nombre: '',
                correo: '',
                telefono: '',
                mensaje: ''
              }
            }, 1000)
          })
        }, error => {
          console.log('FAILED...', error)
        })
    }
  }
}
</script>
